/* Esprit Salopette — contact WhatsApp avec le produit en contexte.
   - Fiche produit : les liens WhatsApp des sections de la page (pas le panier, l'en-tête ni le pied de page)
     reçoivent le nom et le lien du produit, puis la variante dès que le visiteur en choisit une.
     Les liens vers /pages/contact reçoivent ?produit=…(&variante=…).
   - Page Contact : lit ?produit et ?variante, récupère le produit dans Shopify et complète les messages.
   Les messages restent modifiables dans WhatsApp : rien n'est envoyé automatiquement. Sans JavaScript, les liens
   gardent leur message de base. */
(() => {
  const SCOPE = '[id^="shopify-section-template"]';
  let product = null; // { title, url, handle }
  let variant = null; // { id, title } — uniquement après un choix réel

  const readContext = () => {
    const el = document.getElementById('es-contact-product');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  };

  const modelLine = () => product.title + (variant && variant.title && variant.title !== 'Default Title' ? ' – ' + variant.title : '');

  const buildText = (base, kind) => {
    if (!product || kind === 'order') return base;
    const lines = base.split('\n');
    const i = lines.findIndex((l) => /^Modèle\s*:/.test(l.trim()));
    if (i > -1) {
      lines[i] = 'Modèle : ' + modelLine();
      lines.splice(i + 1, 0, product.url);
      return lines.join('\n');
    }
    return base + '\n\nModèle : ' + modelLine() + '\n' + product.url;
  };

  const update = () => {
    document.querySelectorAll(SCOPE + ' a[href*="wa.me/"], ' + SCOPE + ' a[href*="api.whatsapp.com/send"]').forEach((a) => {
      let url;
      try { url = new URL(a.href); } catch (e) { return; }
      if (!a.dataset.esWaBase) {
        const text = url.searchParams.get('text');
        if (text === null) return;
        a.dataset.esWaBase = text;
        a.dataset.esWaPhone = url.hostname === 'wa.me' ? url.pathname.replace(/\D/g, '') : (url.searchParams.get('phone') || '').replace(/\D/g, '');
      }
      if (!a.dataset.esWaPhone) return;
      a.href = 'https://wa.me/' + a.dataset.esWaPhone + '?text=' + encodeURIComponent(buildText(a.dataset.esWaBase, a.dataset.esWa || ''));
    });
    if (!product || !product.handle) return;
    document.querySelectorAll(SCOPE + ' a[href*="/pages/contact"]').forEach((a) => {
      const url = new URL(a.href, location.origin);
      if (url.pathname.replace(/\/$/, '').split('/').pop() !== 'contact') return;
      url.searchParams.set('produit', product.handle);
      if (variant && variant.id) url.searchParams.set('variante', variant.id); else url.searchParams.delete('variante');
      a.href = url.pathname + url.search + url.hash;
    });
  };

  const showContext = () => {
    const el = document.querySelector('[data-es-contact-context]');
    if (!el || !product) return;
    el.textContent = '';
    el.append('Ton message mentionnera : ');
    const strong = document.createElement('strong');
    strong.textContent = modelLine();
    el.append(strong);
    el.hidden = false;
  };

  const onVariant = (event) => {
    const v = event.detail && event.detail.variant;
    if (!v || !product) return;
    variant = { id: v.id, title: v.public_title || v.title };
    update();
  };

  const init = async () => {
    product = readContext();
    const params = new URLSearchParams(location.search);
    const handle = params.get('produit');
    if (!product && handle && /^[a-z0-9-]+$/i.test(handle)) {
      try {
        const res = await fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } });
        if (res.ok) {
          const p = await res.json();
          product = { title: p.title, handle: p.handle, url: location.origin + '/products/' + p.handle };
          const vid = Number(params.get('variante'));
          const v = vid && p.variants.find((x) => x.id === vid);
          if (v) variant = { id: v.id, title: v.public_title || v.title };
        }
      } catch (e) { /* lien de base conservé */ }
      showContext();
    }
    update();
  };

  document.addEventListener('es:variant-change', onVariant);
  document.addEventListener('variant:change', onVariant);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
